"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporationsFilter = void 0;
const vue_1 = require("vue");
const CardName_1 = require("../../CardName");
const AllCards_1 = require("../../cards/AllCards");
const GameModule_1 = require("../../GameModule");
function corpCardNames(module) {
    const manifest = AllCards_1.MANIFEST_BY_MODULE.get(module);
    if (manifest === undefined) {
        console.log('manifest %s not found', manifest);
        return [];
    }
    else {
        const cards = [];
        manifest.corporationCards.factories.forEach((cf) => {
            if (cf.cardName !== CardName_1.CardName.BEGINNER_CORPORATION) {
                cards.push(cf.cardName);
            }
        });
        return cards;
    }
}
const allItems = [];
AllCards_1.ALL_CARD_MANIFESTS.filter((m) => m.module !== GameModule_1.GameModule.Automa).forEach((manifest) => {
    manifest.corporationCards.factories.forEach((cf) => {
        allItems.push(cf.cardName);
    });
});
exports.CorporationsFilter = vue_1.default.component('corporations-filter', {
    props: {
        corporateEra: {
            type: Boolean,
        },
        prelude: {
            type: Boolean,
        },
        preludeTwo: {
            type: Boolean,
        },
        venusNext: {
            type: Boolean,
        },
        colonies: {
            type: Boolean,
        },
        turmoil: {
            type: Boolean,
        },
        promoCardsOption: {
            type: Boolean,
        },
        communityCardsOption: {
            type: Boolean,
        },
        aresExtension: {
            type: Boolean,
        },
        moonExpansion: {
            type: Boolean,
        },
    },
    data: function () {
        const cardsByModuleMap = new Map(AllCards_1.ALL_CARD_MANIFESTS.filter((m) => m.module !== GameModule_1.GameModule.Automa).map((m) => [m.module, corpCardNames(m.module).sort()]));
        return {
            cardsByModuleMap: cardsByModuleMap,
            customCorporationsList: false,
            selectedCorporations: [
                ...cardsByModuleMap.get(GameModule_1.GameModule.Base),
                ...this.corporateEra ? cardsByModuleMap.get(GameModule_1.GameModule.CorpEra) : [],
                ...this.prelude ? cardsByModuleMap.get(GameModule_1.GameModule.Prelude) : [],
                ...this.preludeTwo ? cardsByModuleMap.get(GameModule_1.GameModule.PreludeTwo) : [],
                ...this.venusNext ? cardsByModuleMap.get(GameModule_1.GameModule.Venus) : [],
                ...this.colonies ? cardsByModuleMap.get(GameModule_1.GameModule.Colonies) : [],
                ...this.turmoil ? cardsByModuleMap.get(GameModule_1.GameModule.Turmoil) : [],
                ...this.promoCardsOption ? cardsByModuleMap.get(GameModule_1.GameModule.Promo) : [],
                ...this.communityCardsOption ? cardsByModuleMap.get(GameModule_1.GameModule.Community) : [],
                ...this.aresExtension ? cardsByModuleMap.get(GameModule_1.GameModule.Ares) : [],
                ...this.moonExpansion ? cardsByModuleMap.get(GameModule_1.GameModule.Moon) : [],
            ],
            corpsByModule: Array.from(cardsByModuleMap),
        };
    },
    methods: {
        getSelected: function () {
            if (Array.isArray(this.selectedCorporations)) {
                return this.selectedCorporations;
            }
            console.warn('unexpectedly got boolean for selectedCorporations');
            return [];
        },
        getItemsByGroup: function (group) {
            if (group === 'All')
                return allItems.slice();
            const corps = this.cardsByModuleMap.get(group);
            if (corps === undefined) {
                console.log('module %s not found', group);
                return [];
            }
            else {
                return corps.slice();
            }
        },
        selectAll: function (group) {
            const items = this.getItemsByGroup(group);
            for (const item of items) {
                if (this.getSelected().includes(item) === false) {
                    this.getSelected().push(item);
                }
            }
        },
        removeFromSelection: function (cardName) {
            const itemIdx = this.getSelected().indexOf(cardName);
            if (itemIdx !== -1) {
                this.getSelected().splice(itemIdx, 1);
            }
        },
        selectNone: function (group) {
            const items = this.getItemsByGroup(group);
            for (const item of items) {
                this.removeFromSelection(item);
            }
        },
        invertSelection: function (group) {
            const items = this.getItemsByGroup(group);
            for (const idx in items) {
                if (this.getSelected().includes(items[idx])) {
                    this.removeFromSelection(items[idx]);
                }
                else {
                    this.getSelected().push(items[idx]);
                }
            }
        },
        getExpansionIcon: function (corpName) {
            switch (corpName) {
                case CardName_1.CardName.APHRODITE:
                case CardName_1.CardName.CELESTIC:
                case CardName_1.CardName.MORNING_STAR_INC:
                    return `<span class='create-game-expansion-icon expansion-icon-venus expansion-icon-small'></span>`;
                case CardName_1.CardName.ARIDOR:
                case CardName_1.CardName.POSEIDON:
                case CardName_1.CardName.COLONIAL_ONE:
                    return `<span class='create-game-expansion-icon expansion-icon-colony expansion-icon-small'></span>`;
                case CardName_1.CardName.SEPTUM_TRIBUS:
                case CardName_1.CardName.INCITE:
                case CardName_1.CardName.MARS_COALITION:
                    return `<span class='create-game-expansion-icon expansion-icon-turmoil expansion-icon-small'></span>`;
                case CardName_1.CardName.NANOTECH_INDUSTRIES:
                case CardName_1.CardName.THE_DARKSIDE_OF_THE_MOON_SYNDICATE:
                case CardName_1.CardName.LUNA_HYPERLOOP_CORPORATION:
                case CardName_1.CardName.CRESCENT_RESEARCH_ASSOCIATION:
                case CardName_1.CardName.LUNA_FIRST_INCORPORATED:
                case CardName_1.CardName.THE_GRAND_LUNA_CAPITAL_GROUP:
                case CardName_1.CardName.INTRAGEN_SANCTUARY_HEADQUARTERS:
                case CardName_1.CardName.THE_ARCHAIC_FOUNDATION_INSTITUTE:
                    return `<span class='create-game-expansion-icon expansion-icon-themoon expansion-icon-small'></span>`;
                case CardName_1.CardName.ATHENA:
                case CardName_1.CardName.ERIS:
                    return `<span class='create-game-expansion-icon expansion-icon-ares expansion-icon-small'></span>`;
                default:
                    return '';
            }
        },
    },
    watch: {
        selectedCorporations: function (value) {
            this.$emit('corporation-list-changed', value);
        },
        corporateEra: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.CorpEra) : this.selectNone(GameModule_1.GameModule.CorpEra);
        },
        prelude: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Prelude) : this.selectNone(GameModule_1.GameModule.Prelude);
        },
        preludeTwo: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.PreludeTwo) : this.selectNone(GameModule_1.GameModule.PreludeTwo);
        },
        venusNext: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Venus) : this.selectNone(GameModule_1.GameModule.Venus);
        },
        colonies: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Colonies) : this.selectNone(GameModule_1.GameModule.Colonies);
        },
        turmoil: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Turmoil) : this.selectNone(GameModule_1.GameModule.Turmoil);
        },
        promoCardsOption: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Promo) : this.selectNone(GameModule_1.GameModule.Promo);
        },
        communityCardsOption: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Community) : this.selectNone(GameModule_1.GameModule.Community);
        },
        aresExtension: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Ares) : this.selectNone(GameModule_1.GameModule.Ares);
        },
        moonExpansion: function (enabled) {
            enabled ? this.selectAll(GameModule_1.GameModule.Moon) : this.selectNone(GameModule_1.GameModule.Moon);
        },
    },
    template: `
    <div class="corporations-filter">
        <div class="corporations-filter-toolbox-cont">
            <h2 v-i18n>Corporations</h2>
            <div class="corporations-filter-toolbox corporations-filter-toolbox--topmost">
                <a href="#" v-i18n v-on:click.prevent="selectAll('All')">All*</a> |
                <a href="#" v-i18n v-on:click.prevent="selectNone('All')">None*</a> |
                <a href="#" v-i18n v-on:click.prevent="invertSelection('All')">Invert*</a>
            </div>
        </div>
        <br/>
        <div class="corporations-filter-group" v-for="entry in corpsByModule" v-if="entry[1].length > 0">
            <h3 v-i18n>{{ entry[0] }}</h3>
            <div class="corporations-filter-toolbox-cont">
                <div class="corporations-filter-toolbox">
                    <a href="#" v-i18n v-on:click.prevent="selectAll(entry[0])">All</a> |
                    <a href="#" v-i18n v-on:click.prevent="selectNone(entry[0])">None</a> |
                    <a href="#" v-i18n v-on:click.prevent="invertSelection(entry[0])">Invert</a>
                </div>
            </div>
            <div v-for="corporation in entry[1]">
                <label class="form-checkbox">
                    <input type="checkbox" v-model="selectedCorporations" :value="corporation"/>
                    <i class="form-icon"></i>{{ corporation }}
                    <div v-if="getExpansionIcon(corporation) !== ''" v-html="getExpansionIcon(corporation)" style="display:inline-block"></div>
                </label>
            </div>
        </div>
    </div>
    `,
});
//# sourceMappingURL=CorporationsFilter.js.map